export default "__VITE_ASSET__D8QZ_R6b__"